import React, { useState } from "react";
import { Link } from "react-router-dom";
import { FaUser, FaUserCircle, FaBars, FaTimes, FaWhatsapp } from "react-icons/fa";
import { Modal } from "react-bootstrap";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  const [contactModalShow, setContactModalShow] = useState(false);
  const isLoggedIn = localStorage.getItem("isLoggedIn") === "true";
  const currentUser = JSON.parse(localStorage.getItem("currentUser"));

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      {/* Main Navbar */}
      <nav className="bg-white shadow-lg fixed top-0 left-0 w-full z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-3">
          <div className="flex items-center justify-between">
            {/* Logo */}
            <Link to="/" className="flex items-center">
              <img
                src={`${process.env.PUBLIC_URL}/assets/log.png`}
                alt="Metro Sacco Logo"
                className="h-10 sm:h-12 md:h-14"
              />
            </Link>

            {/* Desktop Navigation - Main */}
            <div className="hidden lg:flex items-center space-x-4 xl:space-x-6">
              <NavLink to="/" text="HOME" />
              <NavLink to="/#about-us" text="ABOUT" />
              <NavLink to="/products" text="PRODUCTS" />
              <NavLink to="/membership" text="MEMBERSHIP" />
              <NavLink to="/downloads" text="DOWNLOADS" />
              <NavLink to="/calculator" text="LOAN CALCULATOR" className="whitespace-nowrap" />
            </div>

            {/* Desktop Login Button */}
            <div className="hidden lg:flex items-center">
              {isLoggedIn ? (
                <NavLink 
                  to="/user/dashboard" 
                  text={`WELCOME, ${currentUser?.name || "USER"}`} 
                  className="whitespace-nowrap"
                />
              ) : (
                <a
                  href="https://memberportal.metro-sacco.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center px-4 py-2 bg-green-600 text-white rounded-md hover:bg-green-700 transition-colors whitespace-nowrap text-sm"
                >
                  <FaUser className="mr-2" /> LOGIN
                </a>
              )}
            </div>

            {/* Mobile Menu Toggle */}
            <button
              onClick={toggleMenu}
              aria-label="Toggle Menu"
              className="lg:hidden text-gray-700 focus:outline-none p-2"
            >
              {isOpen ? <FaTimes className="h-6 w-6" /> : <FaBars className="h-6 w-6" />}
            </button>
          </div>
        </div>

        {/* Secondary Navbar - Desktop Only */}
        <div className="hidden lg:block bg-gray-100 border-t border-gray-300">
          <div className="max-w-7xl mx-auto px-6 py-2">
            <div className="flex justify-end space-x-4">
              <NavLink to="/paymentdetails" text="PAYMENT DETAILS" className="text-xs px-3 py-1" />
              <NavLink to="/newsandevents" text="NEWS AND EVENTS" className="text-xs px-3 py-1" />
              <NavLink to="/faqs" text="FAQ" className="text-xs px-3 py-1" />
              <a
                href="https://wa.me/254785278786?text=Hello%2C%20I%20want..."
                target="_blank"
                rel="noopener noreferrer"
                className="text-xs inline-flex items-center text-red-600 border border-red-600 px-3 py-1 rounded-md hover:bg-red-600 hover:text-white transition duration-300 ease-in-out"
              >
                <FaWhatsapp className="mr-2" /> Contact Us
              </a>
            </div>
          </div>
        </div>
      </nav>

      {/* Mobile Menu Overlay */}
      {isOpen && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-50 z-40 lg:hidden"
          onClick={() => setIsOpen(false)}
        />
      )}

      {/* Mobile Menu Panel */}
      <div
        className={`fixed top-0 left-0 h-full w-4/5 max-w-xs bg-white shadow-xl z-50 transform transition-transform duration-300 ease-in-out lg:hidden ${
          isOpen ? "translate-x-0" : "-translate-x-full"
        }`}
      >
        {/* Mobile Menu Header */}
        <div className="flex items-center justify-between p-4 border-b">
          <span className="text-lg font-semibold">Menu</span>
          <button
            onClick={() => setIsOpen(false)}
            className="text-gray-700 focus:outline-none p-2"
          >
            <FaTimes className="h-5 w-5" />
          </button>
        </div>

        {/* Mobile Menu Content */}
        <div className="overflow-y-auto h-[calc(100%-64px)]">
          <div className="p-4 space-y-2">
            <MobileNavLink to="/" text="HOME" onClick={() => setIsOpen(false)} />
            <MobileNavLink to="/#about-us" text="ABOUT" onClick={() => setIsOpen(false)} />
            <MobileNavLink to="/products" text="PRODUCTS" onClick={() => setIsOpen(false)} />
            <MobileNavLink to="/membership" text="MEMBERSHIP" onClick={() => setIsOpen(false)} />
            <MobileNavLink to="/downloads" text="DOWNLOADS" onClick={() => setIsOpen(false)} />
            <MobileNavLink to="/calculator" text="LOAN CALCULATOR" onClick={() => setIsOpen(false)} />
          </div>

          {/* Mobile Secondary Links */}
          <div className="border-t border-gray-200 p-4 space-y-2">
            <MobileNavLink to="/paymentdetails" text="PAYMENT DETAILS" onClick={() => setIsOpen(false)} />
            <MobileNavLink to="/newsandevents" text="NEWS AND EVENTS" onClick={() => setIsOpen(false)} />
            <MobileNavLink to="/faqs" text="FAQ" onClick={() => setIsOpen(false)} />
            <a
              href="https://wa.me/254785278786?text=Hello%2C%20I%20want..."
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => setIsOpen(false)}
              className="flex items-center w-full text-left py-2 px-4 text-red-600 hover:bg-red-50 transition-colors rounded text-sm"
            >
              <FaWhatsapp className="mr-3" /> Contact Us
            </a>
          </div>

          {/* Mobile Login Section */}
          <div className="border-t border-gray-200 p-4 mt-4">
            {isLoggedIn ? (
              <Link
                to="/user/dashboard"
                onClick={() => setIsOpen(false)}
                className="flex items-center py-3 px-4 bg-green-50 text-green-700 rounded-md hover:bg-green-100 transition-colors text-sm font-medium"
              >
                <FaUserCircle className="mr-3" />
                Welcome, {currentUser?.name || "USER"}
              </Link>
            ) : (
              <a
                href="https://memberportal.metro-sacco.com/"
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => setIsOpen(false)}
                className="flex items-center justify-center py-3 px-4 bg-green-600 text-white rounded-md hover:bg-green-700 transition-colors text-sm font-medium"
              >
                <FaUser className="mr-2" /> LOGIN TO PORTAL
              </a>
            )}
          </div>
        </div>
      </div>

      {/* REMOVED THE SPACER DIV - No space between navbar and content */}
      
      {/* Modals */}
      <MembershipModal show={modalShow} onHide={() => setModalShow(false)} />
      <ContactModal show={contactModalShow} onHide={() => setContactModalShow(false)} />
    </>
  );
};

const NavLink = ({ to, text, onClick, className = "" }) => (
  <Link 
    to={to} 
    onClick={onClick} 
    className={`text-sm font-medium text-gray-700 hover:text-green-600 transition-colors ${className}`}
  >
    {text}
  </Link>
);

const MobileNavLink = ({ to, text, onClick }) => (
  <Link
    to={to}
    onClick={onClick}
    className="block py-3 px-4 text-gray-700 hover:bg-gray-100 transition-colors rounded-md text-sm font-medium"
  >
    {text}
  </Link>
);

const MembershipModal = ({ show, onHide }) => (
  <Modal show={show} onHide={onHide} centered>
    <div className="bg-white rounded-lg shadow-xl p-6">
      <Modal.Header closeButton>
        <Modal.Title className="text-xl sm:text-2xl font-semibold text-gray-800">
          Membership Eligibility and Conditions
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <ul className="list-disc pl-5 sm:pl-6 space-y-2 sm:space-y-3 text-gray-700">
          <li className="text-sm sm:text-base">Metropolitan hospital employee</li>
          <li className="text-sm sm:text-base">Ladnan hospital employee</li>
          <li className="text-sm sm:text-base">Former staff of affiliated organization</li>
          <li className="text-sm sm:text-base">Individuals referred by existing members</li>
        </ul>
      </Modal.Body>
    </div>
  </Modal>
);

const ContactModal = ({ show, onHide }) => (
  <Modal show={show} onHide={onHide} centered>
    <div className="bg-gradient-to-r from-teal-400 to-green-600 rounded-lg shadow-xl p-6">
      <Modal.Header closeButton>
        <Modal.Title className="text-xl sm:text-2xl font-bold text-white flex items-center">
          <FaUserCircle className="mr-3 text-white text-2xl sm:text-3xl" />
          Contact Information
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="text-white">
        <p className="text-sm sm:text-base">Location: Metropolitan Hospital, Buruburu, Nairobi.</p>
        <p className="text-sm sm:text-base">Cell: 0705767492 / 0785278786</p>
        <p className="text-sm sm:text-base">Email: customercare@metro-sacco.co.ke</p>
        <p className="text-sm sm:text-base">
          Website:{" "}
          <a href="http://www.metro-sacco.co.ke" className="text-white underline">
            www.metro-sacco.co.ke
          </a>
        </p>
      </Modal.Body>
    </div>
  </Modal>
);

export default Navbar;